import { components } from 'react-select';

import { MenuListProps } from './MenuList.types';
import { useStyles } from './MenuList.styles';

export const MenuList = ({ children, ...rest }: MenuListProps) => {
  const styles = useStyles({ menuPlacement: rest.selectProps.menuPlacement });

  return (
    <components.MenuList css={styles.root} {...rest}>
      {children}
    </components.MenuList>
  );
};
